// @flow
import React from 'react';
import classNames from 'classnames';
import { Button as BootstrapButton } from 'reactstrap';

import './Button.scss';

type ButtonTheme = 'default' | 'action' | 'link';
// TODO(mauricio): these values don't match the bootstrap button types, decide
// whether we're going to support these values or transition to the sm/lg
// versions found in bootstrap
type ButtonSize = 'small' | 'medium' | 'large';

type BootstrapButtonProps = {
  /** Additional classname applied to the root element */
  className?: string,
  /** True to make the button disabled (also adds the --disabled state) */
  disabled?: boolean,
  /** Button size */
  size: ButtonSize
};

type OwnProps = {
  /** Button theme */
  buttonTheme: ButtonTheme
};

type Props = OwnProps & BootstrapButtonProps;

class Button extends React.Component<Props> {
  static block = 'button';

  render() {
    const {
      buttonTheme,
      size,
      className,
      disabled,
      ...otherProps
    } = this.props;
    const ns = Button.block;
    const computedClassName = classNames(
      ns,
      `${ns}--${buttonTheme || 'default'}`,
      {
        [`${ns}--${size}`]: size,
        [`${ns}--disabled`]: disabled
      },
      className
    );
    // forward props taken by this component as well
    return (
      <BootstrapButton
        disabled={disabled}
        className={computedClassName}
        size={size}
        {...otherProps}
      />
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/atoms/Button/Button.js